import useMediaQuery from '@mui/material/useMediaQuery';
import { Suspense, lazy, useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import routes from '../../Utils/Constants/routes';
import { useTheme } from '@emotion/react';
import { TABLET_BREAKPOINT } from '../../Utils/Constants/constant';
import { getAxiosInstance } from '../../Utils/apiServices';
import { PrivateRouter, PublicRouter } from '../../Utils/Helpers/applicationHelper';
import KenLoader from '../../Components/KenLoader/index.jsx';

const AppLayout = lazy(() => import('../../Components/AppLayout'));
const HomePage = lazy(() => import('../HomePage'));
const DocumentPage = lazy(() => import('../DocumentPage'));
const Login = lazy(() => import('../Auth/Login'));
const SignUp = lazy(() => import('../Auth/SignUp'));
const Courses = lazy(() => import('../Courses'));
const MyApplications = lazy(() => import('../MyApplications'));
const ApplicationFormNew = lazy(() => import('../ApplicationForm'));
const PaymentHistory = lazy(() => import('../PaymentHistory'));
const LandingPageCommon = lazy(() => import('../../Containers/LandingPageCommonPage'));
const DEMLandingPage = lazy(() => import('../DEMLandingPage/index.js'));
const GSCMLandingPage = lazy(() => import('../GSCMLandingPage/index.js'));
const Faq = lazy(() => import('../FAQ'));
const CourseEligibility = lazy(() => import('../CourseEligibility'));
const ThankyouScreen = lazy(() => import('../Auth/ThankyouForRegistering'));
const ConfirmingEmail = lazy(() => import('../Auth/ConfirmingEmail'));
const ResetPassword = lazy(() => import('../Auth/ResetPassword'));
const ResetPasswordMain = lazy(() => import('../Auth/ResetPasswordMain'));
const QueryHistory = lazy(() => import('../../Containers/RaiseaQuery/Components/QueryHistory'));
const QueryOverview = lazy(() => import('../../Containers/RaiseaQuery/Components/ReviewRequest'));
const EMBALandingPage = lazy(() => import('../EMBALandingPage/index.js'));
const SPMLandingPage = lazy(() => import('../SPMLandingPage/index.js'));
const PhDLandingPage = lazy(() => import('../PhDLandingPage/index.js'));
const EphdLandingPage = lazy(() => import('../EphdLandingPage/index.js'));
const TwoyearmbaInternationallandingpage = lazy(() => import('../TwoyearmbaInternationallandingpage/index.js'));
const StudentInterviewModule = lazy(() => import('../studentInterviewModule/index.js'));
const InterviewBookslotTab = lazy(() => import('../studentInterviewModule/Components/InterviewBookslotTab/index.jsx'));
const CommonInternationalLandingPage = lazy(() => import('../CommonInternationalLandingPage/index.js'));
const Withdrawal = lazy(() => import('../Withdrawal'));
const WithDrawDetails = lazy(() => import('../Withdrawal/WithdrawalDetails'));
const PostApplicationPage = lazy(() => import('../PostApplicationPage'));
const OnBoarding = lazy(() => import("../Onboarding"))
const TravelGatePass = lazy(() => import("../TravelGatePass"))

export default function MainLayout() {
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down(TABLET_BREAKPOINT));
  getAxiosInstance();

  useEffect(() => {
    const isWindows = navigator.platform.startsWith('Win');

    if (!isWindows) {
      console.log('Non-Windows platform — skipping zoom detection');
      return;
    }

    const detectZoomLevel = () => {
      const ratio = window.devicePixelRatio || 1;
      return Math.round(ratio * 100); // 100 = normal, 125 = 125% zoom, etc.
    };

    const updateZoomClass = () => {
      const zoom = detectZoomLevel();

      console.log('Detected Zoom Level:', zoom + '%');

      // Remove old zoom classes
      document.body.classList.remove('scale-100', 'scale-125', 'scale-150');

      let scaleClass = 'scale-100';
      if (zoom >= 145) {
        scaleClass = 'scale-150';
      } else if (zoom >= 115) {
        scaleClass = 'scale-125';
      }

      document.body.classList.add(scaleClass);
      console.log('Applied class to <body>:', scaleClass);
    };

    // Initial call
    updateZoomClass();

    // Update dynamically on resize (or zoom)
    window.addEventListener('resize', updateZoomClass);

    return () => {
      window.removeEventListener('resize', updateZoomClass);
    };
  }, []);

  return (
    <Suspense fallback={<KenLoader />}>
      <Routes>
        <Route caseSensitive path={`*`} element={<Navigate to={routes.landingPage} />} />
        {/* Public Router */}
        <Route caseSensitive path={routes.verify} element={<ConfirmingEmail />} />
        <Route
          exact
          caseSensitive
          path={`/`}
          element={
            <PublicRouter>
              <LandingPageCommon />
            </PublicRouter>
          }
        />
        {/* <Route
          caseSensitive
          path={routes.demlandingpage}
          element={
            <PublicRouter>
              <DEMLandingPage />
            </PublicRouter>
          }
        /> */}
        {/* <Route
          caseSensitive
          path={routes.gscmlandingpage}
          element={
            <PublicRouter>
              <GSCMLandingPage />
            </PublicRouter>
          }
        /> */}
        {/* <Route
          caseSensitive
          path={routes.embalandingpage}
          element={
            <PublicRouter>
              <EMBALandingPage />
            </PublicRouter>
          }
        /> */}
        {/* <Route
          caseSensitive
          path={routes.spmlandingpage}
          element={
            <PublicRouter>
              <SPMLandingPage />
            </PublicRouter>
          }
        /> */}
        {/* <Route
          caseSensitive
          path={routes.phdlandingpage}
          element={
            <PublicRouter>
              <PhDLandingPage />
            </PublicRouter>
          }
        /> */}
        {/* <Route
          caseSensitive
          path={routes.ephdlandingpage}
          element={
            <PublicRouter>
              <EphdLandingPage />
            </PublicRouter>
          }
        /> */}
        {/* <Route
          caseSensitive
          path={routes.spmlandingpage}
          element={
            <PublicRouter>
              <SPMLandingPage />
            </PublicRouter>
          }
        /> */}
        {/* <Route
          caseSensitive
          path={routes.phdlandingpage}
          element={
            <PublicRouter>
              <PhDLandingPage />
            </PublicRouter>
          }
        /> */}
        {/* <Route
          caseSensitive
          path={routes.twoyearmbaInternationallandingpage}
          element={
            <PublicRouter>
              <TwoyearmbaInternationallandingpage />
            </PublicRouter>
          }
        /> */}
        {/* <Route
          caseSensitive
          path={routes.commonInternationalLandingPage}
          element={
            <PublicRouter>
              <CommonInternationalLandingPage />
            </PublicRouter>
          }
        />  */}
        <Route
          caseSensitive
          path={routes.login}
          element={
            <PublicRouter>
              <Login />
            </PublicRouter>
          }
        />
        <Route
          caseSensitive
          path={routes.signup}
          element={
            <PublicRouter>
              <SignUp />
            </PublicRouter>
          }
        />
        <Route
          caseSensitive
          path={routes.success}
          element={
            <PublicRouter>
              <ThankyouScreen />
            </PublicRouter>
          }
        />
        <Route
          caseSensitive
          path={routes.resetpassword}
          element={
            <PublicRouter>
              <ResetPassword />
            </PublicRouter>
          }
        />
        <Route
          caseSensitive
          path={routes.resendVerification}
          element={
            <PublicRouter>
              <ResetPassword />
            </PublicRouter>
          }
        />
        {/* Public gate pass view — opened when security scans the QR code */}
        <Route
          caseSensitive
          path={routes.travelGatePass}
          element={<TravelGatePass />}
        />

        {/* Private Router */}
        <Route
          caseSensitive
          path={routes.applicationForm}
          element={
            <PrivateRouter>
              {isMobileScreen ? (
                <AppLayout>
                  <ApplicationFormNew />
                </AppLayout>
              ) : (
                <ApplicationFormNew />
              )}
            </PrivateRouter>
          }
        />

        {/* Layout Routes */}
        <Route caseSensitive path="/app" element={<AppLayout />}>
          <Route
            caseSensitive
            path={routes.resetPasswordMain}
            element={
              <PrivateRouter>
                <ResetPasswordMain />
              </PrivateRouter>
            }
          />
          <Route
            caseSensitive
            path={'home'}
            element={
              <PrivateRouter>
                <HomePage />
              </PrivateRouter>
            }
          />
          <Route
            caseSensitive
            path={'document'}
            element={
              <PrivateRouter>
                <DocumentPage />
              </PrivateRouter>
            }
          />
          <Route
            caseSensitive
            path={`paymentHistory`}
            element={
              <PrivateRouter>
                <PaymentHistory />
              </PrivateRouter>
            }
          />
          <Route
            caseSensitive
            path={`faq`}
            element={
              <PrivateRouter>
                <Faq />
              </PrivateRouter>
            }
          />
          <Route
            caseSensitive
            path={'courses'}
            element={
              <PrivateRouter>
                <Courses />
              </PrivateRouter>
            }
          />
          <Route
            caseSensitive
            path={'my-applications'}
            element={
              <PrivateRouter>
                <MyApplications />
              </PrivateRouter>
            }
          />
          <Route
            caseSensitive
            path={'eligibility'}
            element={
              <PrivateRouter>
                <CourseEligibility />
              </PrivateRouter>
            }
          />
          <Route
            caseSensitive
            path={'post-application'}
            element={
              <PrivateRouter>
                <PostApplicationPage />
              </PrivateRouter>
            }
          />
          <Route
            caseSensitive
            path={'queryHistory'}
            element={
              <PrivateRouter>
                <QueryHistory />
              </PrivateRouter>
            }
          />
          <Route
            caseSensitive
            path={'queryView'}
            element={
              <PrivateRouter>
                <QueryOverview />
              </PrivateRouter>
            }
          />
          <Route
            caseSensitive
            path={'studentInterviewTab'}
            element={
              <PrivateRouter>
                <StudentInterviewModule />
              </PrivateRouter>
            }
          />
          <Route
            caseSensitive
            path={'slotInterviewBooking'}
            element={
              <PrivateRouter>
                <InterviewBookslotTab />
              </PrivateRouter>
            }
          />
          <Route
            caseSensitive
            path={'withdraw'}
            element={
              <PrivateRouter>
                <Withdrawal />
              </PrivateRouter>
            }
          />
          <Route
            caseSensitive
            path={'withdrawDetails'}
            element={
              <PrivateRouter>
                <WithDrawDetails />
              </PrivateRouter>
            }
          />
          <Route
            caseSensitive
            path={'on-boarding'}
            element={
              <PrivateRouter>
                <OnBoarding />
              </PrivateRouter>
            }
          />
        </Route>
      </Routes>
    </Suspense>
  );
}
